module.exports = __webpack_public_path__ + "static/media/endoplasmic-reticulum.e6447561.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/endoplasmic-reticulum.svg
// module id = 672
// module chunks = 0